/* src/app/front-layout/consortiums/page-reading-boys/page-reading-boys.component.css */
.details-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.spacer {
  height: 25px;
}
.details-header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px;
  overflow: hidden;
}
.details-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.details-banner {
  margin-top: 50px;
  width: 80%;
  height: 200px;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.details-banner h1 {
  font-size: 36px;
  color: #222;
}
.details-banner h2 {
  font-size: 24px;
  color: #0077b6;
}
.details-content {
  width: 70%;
  background: white;
  padding: 40px;
  margin-top: -20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.details-publisher {
  width: 100%;
  background: #0077b6;
  color: white;
  padding: 10px;
  font-size: 14px;
  text-align: left;
  margin-bottom: 20px;
}
.details-section h3 {
  font-size: 28px;
  margin-bottom: 15px;
  color: #222;
}
.details-section p {
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 15px;
}
.details-section div {
  display: flex;
  align-items: center;
  gap: 10px;
}
.details-section div img {
  width: 25px;
  height: 25px;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}
th {
  background-color: #f4f4f4;
}
table a {
  text-decoration: none;
  color: #0077b6;
  font-weight: bold;
}
a:hover {
  text-decoration: underline;
}
@media (max-width: 768px) {
  .details-header {
    margin-top: 50px;
    height: 300px;
  }
  .details-banner {
    width: 90%;
    height: auto;
    padding: 20px;
    margin-top: 30px;
  }
  .details-banner h1 {
    font-size: 28px;
  }
  .details-banner h2 {
    font-size: 20px;
  }
  .details-content {
    width: 90%;
    padding: 20px;
  }
  .details-section h3,
  .details-section h2 {
    font-size: 24px;
  }
  .details-section p {
    font-size: 16px;
    text-align: justify;
  }
  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  .exam-info {
    padding: 15px;
    margin: 30px 0;
  }
  .exam-info h2 {
    font-size: 22px;
  }
  .details-section div {
    align-items: flex-start;
    margin: 10px 0;
  }
  .details-section div img {
    margin-bottom: 8px;
  }
  img[src*=chart] {
    max-width: 100%;
    height: auto;
  }
  .details-publisher {
    font-size: 12px;
    text-align: center;
    padding: 8px;
  }
}
@media (max-width: 480px) {
  .details-header {
    height: 250px;
  }
  .details-banner h1 {
    font-size: 24px;
  }
  .details-banner h2 {
    font-size: 18px;
  }
  .details-content {
    width: 100%;
    padding: 15px;
  }
  .details-section h3,
  .details-section h2 {
    font-size: 22px;
  }
  .exam-info h2 {
    font-size: 20px;
  }
  .spacer {
    height: 15px;
  }
}
/*# sourceMappingURL=page-reading-boys.component.css.map */
